export default __webpack_public_path__ + "static/media/bannerImg6.b3b26617.png";